import React from 'react';
import {observer} from 'mobx-react';
import * as util from '../../../util';

const LevelLockModal: React.FC = observer(() => {
    return (
        <button
            className="link link-btn"
            onClick={() => util.modal('modal-level-lock')}
            aria-label="Open information about Level-Lock Frame Hanging System"
            type="button"
            aria-haspopup="dialog"
            aria-controls="modal-level-lock"
        >
            Level-Lock Frame Hanging System
        </button>
    );
});

export default LevelLockModal;
